// extracted by mini-css-extract-plugin
export default {"notification":"i0YJw","notification-wrapper":"urjkv","notificationWrapper":"urjkv","tooltip":"_1RvT4","new-tooltip":"uTvPB","newTooltip":"uTvPB"};